import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import HotSection from './components/HotSection';
import CollectionSection from './components/CollectionSection';
import LatestSection from './components/LatestSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩国漫画网-好看的韩国漫画_韩漫在线免费阅读_韩漫大全"
        description="韩国漫画网汇聚了众多好看的韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门与精选作品，满足您的一切阅读期待。每日更新最新韩漫章节，提供高品质阅读体验。"
        keywords="韩国漫画网,好看的韩国漫画,韩漫在线免费阅读,韩漫大全,热门作品,精选合集"
        canonicalUrl="https://www.koreanmanhwa.com/"
        ogTitle="韩国漫画网-好看的韩国漫画_韩漫在线免费阅读_韩漫大全"
        ogDescription="韩国漫画网汇聚了众多好看的韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门与精选作品。"
        ogType="website"
        ogUrl="https://www.koreanmanhwa.com/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "韩国漫画网",
            "url": "https://www.koreanmanhwa.com/",
            "description": "韩国漫画网汇聚了众多好看的韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门与精选作品。",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://www.koreanmanhwa.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "韩国漫画网",
            "url": "https://www.koreanmanhwa.com/",
            "description": "韩国漫画在线阅读平台",
            "contactPoint": {
              "@type": "ContactPoint",
              "email": "contact@koreanmanhwa.com",
              "contactType": "customer service",
              "availableLanguage": ["Chinese"]
            }
          }
        ]}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <HotSection />
        <CollectionSection />
        <LatestSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}